module.exports = require("effector-inspector");